import * as Yup from 'yup';

// Helper function to convert multilingual data to old format for backward compatibility
export const convertToBackendFormat = (multiLangData) => {
  // If cumulative is false, clear question2 values
  const question2Value = multiLangData.cumulative
    ? multiLangData.question2?.en || multiLangData.question2 || ''
    : '';

  const question2Translations = multiLangData.cumulative
    ? multiLangData.question2
    : { en: '', nl: '' };

  // Use English as primary language (fallback)
  const result = {
    preamble: multiLangData.preamble?.en || multiLangData.preamble || '',
    question1: multiLangData.question1?.en || multiLangData.question1 || '',
    question2: question2Value,
    cumulative: !!multiLangData.cumulative,
    isEnable: multiLangData.isEnable || false,
    translations: {
      preamble: multiLangData.preamble,
      question1: multiLangData.question1,
      question2: question2Translations,
    },
  };

  return result;
};

// Helper function to convert legacy data to multilingual format
export const convertFromBackendFormat = (legacyData) => {
  // If already converted, return as-is
  if (
    legacyData.preamble &&
    typeof legacyData.preamble === 'object' &&
    legacyData.preamble.en !== undefined
  ) {
    return legacyData;
  }

  if (legacyData.translations) {
    return {
      id: legacyData.id,
      preamble: legacyData.translations.preamble || {
        en: legacyData.preamble || '',
      },
      question1: legacyData.translations.question1 || {
        en: legacyData.question1 || '',
      },
      question2: legacyData.translations.question2 || {
        en: legacyData.question2 || '',
      },
      cumulative: !!legacyData.cumulative,
      isEnable: legacyData.isEnable || false,
    };
  }

  // Legacy format without translations
  return {
    id: legacyData.id,
    preamble: { en: legacyData.preamble || '' },
    question1: { en: legacyData.question1 || '' },
    question2: { en: legacyData.question2 || '' },
    cumulative: !!legacyData.cumulative,
    isEnable: legacyData.isEnable || false,
  };
};

export const initialValues = (form) => {
  if (!form) {
    return {
      preamble: { en: '' },
      question1: { en: '' },
      question2: { en: '' },
      cumulative: false,
      isEnable: false,
    };
  }

  return convertFromBackendFormat(form);
};

// Multilingual validation schema
const multiLangStringSchema = (t) =>
  Yup.object().shape({
    en: Yup.string().required(
      t('formulary.validation.english_translation_required')
    ),
    nl: Yup.string().optional(),
  });

// Conditional validation for question2 when cumulative is true
const conditionalQuestion2Schema = (t) =>
  Yup.object().when('cumulative', {
    is: true,
    then: (schema) =>
      schema.shape({
        en: Yup.string().required(
          t('admin.activity_settings.evaluation_questions.question_2_required')
        ),
        nl: Yup.string().optional(),
      }),
    otherwise: (schema) =>
      schema.shape({
        en: Yup.string().optional(),
        nl: Yup.string().optional(),
      }),
  });

export const evaluationQuestionValidation = (t) =>
  Yup.object().shape({
    preamble: multiLangStringSchema(t),
    question1: multiLangStringSchema(t),
    question2: conditionalQuestion2Schema(t),
    cumulative: Yup.boolean().optional(),
    isEnable: Yup.boolean().optional(),
  });
